import { useQuery } from '@hooks/reactQuery';

import { getRUConfigurationUsers } from '@api/ruConfigurations';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IUserListResponse } from '@interfaces/user/user';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_CONFIGURATIONS_USERS } from '@constants/queryKeys';

interface IUseQueryRUConfigurationUsersReturned {
	ruConfigurationUsers: TSelectOption<string>[];
	isLoadingRUConfigurationUsers: boolean;
}

export const useQueryRUConfigurationUsers = (): IUseQueryRUConfigurationUsersReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IUserListResponse[], TSelectOption<string>[]>({
		queryKey: [RU_CONFIGURATIONS_USERS],
		queryFn: getRUConfigurationUsers,
		select: (data) => {
			return mapDropdownOptions({
				items: data,
				valueKey: 'id',
				labelKey: 'fullName',
			});
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		ruConfigurationUsers: data || [],
		isLoadingRUConfigurationUsers: isInitialLoading,
	};
};
